import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { shadows } from 'c1ui/theme/C1Theme'

export const tableGridHeaderStyles = makeStyles((theme: Theme) => {
    return createStyles({
        header: {
            borderTopLeftRadius: C1BorderRadius.large,
            borderTopRightRadius: C1BorderRadius.large,
            padding: theme.spacing(3),
            paddingBottom: theme.spacing(2),
            margin: 0,
            backgroundColor: theme.palette.background.default,
        },
        title: {
            display: 'flex',
            alignItems: 'center',
        },
        info: {
            marginRight: theme.spacing(2),
            display: 'inline-block',
        },
        sticker: {
            fontSize: 14,
        },
        button: {
            marginLeft: theme.spacing(1),
        },
    })
})

export const tableGridStyles = makeStyles((theme: Theme) => {
    return createStyles({
        tableGrid: {
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: C1BorderRadius.large,
            marginBottom: theme.spacing(4),
            boxShadow: shadows.default,
        },
        bodyDefault: {
            padding: theme.spacing(0, 3, 4, 3),
            margin: 0,
        },
        bodyCompact: {
            paddingBottom: theme.spacing(4),
            margin: 0,
        },
        bodyNoPadding: {
            padding: 0,
            margin: 0,
        },
        body: {
            backgroundColor: theme.palette.background.default,
            borderBottomLeftRadius: C1BorderRadius.large,
            borderBottomRightRadius: C1BorderRadius.large,
            paddingBottom: theme.spacing(4),
        },
    })
})
